<template>
  <div class="page --grey-bg contatti">
    <FormContact :contatti="contatti" />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'

const { configuration } = useStore()

// Fetch Data
const query = queries.contatti.getContatti

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.contattiPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const contatti = computed(() => data.value.contattiPageEntries?.[0])
const seo = computed(() => data.value?.contattiPageEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
